import { DEFAULT_DATES_SINGLE_TITLE } from "~/constants/property";
import { LayoutKind, PropertyKind } from "~/shared/enums";
import type { Property } from "~/shared/types";
import type { useAppStore } from "~/stores";

type AppStore = ReturnType<typeof useAppStore>;

let appStore: AppStore;

export const init = (store: AppStore): void => {
  appStore = store;
};

export const getPropertyDisplayTitle = (property: Property): string => {
  if (
    property.kind === PropertyKind.DEFAULT_DATES &&
    property.title === DEFAULT_DATES_SINGLE_TITLE &&
    [LayoutKind.ROADMAP, LayoutKind.CALENDAR].includes(appStore.layoutKind)
  ) {
    return "Dates";
  }
  return property.title;
};
